module.exports = __webpack_public_path__ + "static/media/bug.ab0e8157.svg";